export type CharacterLanguage = 'ru' | 'en';
const ru: Record<string, string> = {
  introduce: 'Назвать себя',
  settle_debt: 'Оплатить прежний долг',
  wanted_trade_denied: 'Стража разыскивает героя. Торговец отказывается обслуживать.',
  standard_service: 'Обычные условия обслуживания',
  essential_healing: 'Обычная цена необходимого лечения',
  caution_price: 'Торговец осторожничает и повышает цену',
  combat_required: 'Для этого придётся сражаться',
  defend_dignity: 'Защищает своё достоинство',
  acknowledge_known_fault: 'Готов признать свою ошибку',

  fight: 'Вступить в бой',
  help_guards: 'Помочь страже',
  help_bandits: 'Помочь разбойникам',
  observe: 'Наблюдать',
  pay: 'Откупиться',
  reconcile: 'Примириться',
  leave: 'Уйти',
  capture: 'Взять в плен',
  release: 'Отпустить',
  attack_protected: 'Напасть на защищённого пленника',
  compassion: 'Сострадание',
  healing_may_fail: 'Помощь может не спасти пострадавшего',
  possible_resistance: 'Возможно сопротивление',
  travel_danger: 'В пути есть опасность',
  greed: 'Корысть',
  courage: 'Смелость',
  temper: 'Вспыльчивость',
  sociability: 'Общительность',
  conscientiousness: 'Добросовестность',
  independence: 'Самостоятельность',
  pride: 'Гордость',
  protect_helpless: 'Беспомощных нельзя обижать',
  do_not_abandon_allies: 'Своих нельзя бросать',
  help_deserves_payment: 'Помощь заслуживает оплаты',
  law_protects_people: 'Закон защищает людей',
  distrust_guards: 'Страже нельзя доверять',
  keep_promises: 'Обещания нужно выполнять',
  punish_offenders: 'Обидчик должен ответить',
  heal: 'Вылечить зельем',
  paid_help: 'Предложить помощь за плату',
  ignore: 'Пройти мимо',
  rob: 'Ограбить',
  finish: 'Добить',
  own: 'Решил самостоятельно',
  aligned: 'Ваш совет совпал с его решением',
  accepted: 'Прислушался к совету',
  refused: 'Отказался следовать совету',
  partial: 'Согласился частично',
  inapplicable: 'Совет больше недоступен',
  weak_connection: 'Связь с вами ослабла',
  conviction_conflict: 'Совет противоречит убеждению',
  independent_choice: 'Хочет решить сам',
  resource_risk: 'Берегёт необходимые припасы',
  public_dignity: 'Дорожит достоинством',
  known_betrayal: 'Помнит предательство',
  preserve_resources: 'Хочет сохранить припасы',
  help_suffering: 'Хочет помочь страдающему',
  unaware: 'Ещё не замечает вашего участия',
  senses_guidance: 'Ощущает подсказки',
  recognizes_voice: 'Узнаёт ваш голос',
  aware: 'Знает, что вы его направляете',
  connection_failed: 'Не удалось связаться с миром. Повторите попытку.',
  advice_processing:
    'Проверяем, сохранился ли совет. Повтор запроса безопасен.',
  character_refreshing: 'Загружаем характер героя…',
  hero_busy: 'Герой занят. Повторите попытку.',
  encounter_changed: 'Ситуация изменилась. Обновляем сведения.',
  advice_too_late: 'Герой уже принял решение.',
  advice_already_recorded: 'Для этой встречи совет уже записан.',
  preferred_alternative: 'Другое решение кажется ему лучше',
  external_pressure: 'Не хочет уступать давлению',
  reduced_conviction_conflict: 'Выбрал поступок, ближе к своим убеждениям',
  unavailable_action_or_target: 'Действие или цель больше недоступны',
  invalid_advice: 'Такой совет сейчас недоступен. Обновите сведения.',
  encounter_completed: 'Встреча уже завершилась.',
  encounter_not_found: 'Эта встреча больше не найдена.',
  advice_binding_conflict:
    'Этот совет уже записан с другим действием. Обновите сведения.',
  character_busy: 'Мир обрабатывает другие события. Повторите попытку.',
  character_timeout: 'Ответ задерживается. Повтор запроса безопасен.',
  character_unavailable: 'Сведения о герое временно недоступны.',
};
const en: Record<string, string> = {
  introduce: 'Introduce yourself',
  settle_debt: 'Settle an earlier debt',
  wanted_trade_denied: 'The hero is wanted. The merchant refuses service.',
  standard_service: 'Standard service conditions',
  essential_healing: 'Standard price for essential healing',
  caution_price: 'The cautious merchant raises the price',
  combat_required: 'This requires a fight',
  defend_dignity: 'Defends their dignity',
  acknowledge_known_fault: 'Ready to admit a known mistake',

  healing_may_fail: 'Help may not save the patient',
  possible_resistance: 'Possible resistance',
  travel_danger: 'Travel danger',
  fight: 'Join the fight',
  help_guards: 'Help the guards',
  help_bandits: 'Help the bandits',
  observe: 'Observe',
  pay: 'Pay to leave',
  reconcile: 'Reconcile',
  leave: 'Leave',
  capture: 'Capture',
  release: 'Release',
  attack_protected: 'Attack the protected captive',
  compassion: 'Compassion',
  greed: 'Greed',
  courage: 'Courage',
  temper: 'Temper',
  sociability: 'Sociability',
  conscientiousness: 'Conscientiousness',
  independence: 'Independence',
  pride: 'Pride',
  protect_helpless: 'Protect the helpless',
  do_not_abandon_allies: 'Never abandon allies',
  help_deserves_payment: 'Help deserves payment',
  law_protects_people: 'Law protects people',
  distrust_guards: 'Distrust guards',
  keep_promises: 'Keep promises',
  punish_offenders: 'Punish offenders',
  heal: 'Heal with a potion',
  paid_help: 'Offer paid help',
  ignore: 'Walk past',
  rob: 'Rob',
  finish: 'Finish off',
  own: 'Decided independently',
  aligned: 'Your advice matched their choice',
  accepted: 'Accepted your advice',
  refused: 'Refused your advice',
  partial: 'Partly agreed',
  inapplicable: 'Advice is no longer available',
  weak_connection: 'Your connection has faded',
  conviction_conflict: 'Conflicts with a belief',
  independent_choice: 'Wants to decide independently',
  resource_risk: 'Protects needed supplies',
  public_dignity: 'Protects their dignity',
  known_betrayal: 'Remembers betrayal',
  preserve_resources: 'Wants to keep supplies',
  help_suffering: 'Wants to help',
  unaware: 'Has not noticed your guidance',
  senses_guidance: 'Senses guidance',
  recognizes_voice: 'Recognizes your voice',
  aware: 'Knows you are guiding them',
  connection_failed: 'Connection failed. Try again.',
  advice_processing:
    'Checking whether your advice was saved. Retrying is safe.',
  character_refreshing: 'Loading the hero’s character…',
  hero_busy: 'The hero is busy. Try again.',
  encounter_changed: 'The situation changed. Refreshing.',
  advice_too_late: 'The hero has already decided.',
  advice_already_recorded: 'Advice has already been recorded.',
  preferred_alternative: 'Another choice seems better to the hero',
  external_pressure: 'Does not want to give in to pressure',
  reduced_conviction_conflict: 'Chose an action closer to their beliefs',
  unavailable_action_or_target: 'The action or target is no longer available',
  invalid_advice: 'This advice is unavailable. Refresh the situation.',
  encounter_completed: 'The encounter has ended.',
  encounter_not_found: 'This encounter could not be found.',
  advice_binding_conflict:
    'This advice already contains another action. Refresh the situation.',
  character_busy: 'The world is processing other events. Try again.',
  character_timeout: 'The response is delayed. Retrying is safe.',
  character_unavailable: 'Character information is temporarily unavailable.',
};
export function characterLabel(
  language: CharacterLanguage,
  key: string,
): string {
  return (
    (language === 'ru' ? ru : en)[key] ??
    (language === 'ru' ? 'Неизвестное событие' : 'Unknown event')
  );
}
